<template>
    <Tree :data="tree" show-checkbox ref="queryResources"></Tree>
</template>
<script>
import { listToTree } from '@/utils/helper'
import { queryResources } from '@/api/act-info'

export default {
    inject: {
        $modal: { default: null }
    },

    props: {
        projId: {
            type: [String, Number],
            default: ''
        }
    },

    data() {
        return {
            list: [],
            defaultIds: {}
        }
    },

    computed: {
        tree() {
            return listToTree(this.list, { id: 'id', pId: 'pid', copy: false })
        }
    },

    methods: {
        setTreeData(org) {
            let list = org.data.list.filter(
                el =>
                    el.type != 'resources' ||
                    el.houseStatus == 1 ||
                    this.defaultIds[el.id]
            )
            list.forEach(el => {
                el.checked = this.defaultIds[el.id] == true // 默认勾选
                el.expand = true
                el.title = el.type == 'unit' ? el.name + '单元' : el.name
                el.spread = el.type === 'resources'
                if(el.type != 'resources') {
                    let item = list.find(val=> val.pid == el.id)
                    el.disabled = item ? false : true
                }
            })
            this.list = list
        }
    },

    created() {
        this.$modal.$on('lookup-open', data => {
            if (!this.projId) {
                this.$Message.warning('请先选择一个活动项目')
                return
            }
            this.defaultIds = {}
            data.forEach(v => (this.defaultIds[v.value] = true))

            // 打开选择框
            this.$modal.beforeEnter(next => {
                queryResources(this.projId).then(res => {
                    this.setTreeData(res)
                    next()
                })
            })

            // 关闭选择框
            this.$modal.onBtnClick('confirm', (next, options) => {
                this.$modal.$emit(
                    'lookup-close',
                    this.list.filter(v => v.checked && v.type == 'resources')
                )
                next()
            })
        })
    }
}
</script>
